import { type CrmData } from '@playbooks/core/src/interfaces/ConnectToCrmWidget'
import { Question } from '@playbooks/core/src/interfaces/ActionCard'

import { processReplacements } from './processReplacements'

function replaceWidgetStaticFields(staticFields: CrmData, questionsWithCode: Question[]) {
  if (staticFields) {
    const stringifiedFields = processReplacements(JSON.stringify(staticFields), questionsWithCode)!
    staticFields = JSON.parse(stringifiedFields)
  }

  return staticFields
}

export default replaceWidgetStaticFields
